// @ts-nocheck
import styled from 'styled-components';
import { getTheme } from 'settings/theme';
import type { StatelessFunctionalComponent } from 'react';

const {
  palette: { greyscale, blue },
} = getTheme();
const SorterWrapper: StatelessFunctionalComponent<any> = styled.div`
  margin-right: 0.8rem;

  .sorter {
    &__main-btn {
      border: 1px solid ${greyscale.outerSpace};
      border-radius: 0.4rem;
      color: ${greyscale.outerSpace};
      cursor: pointer;
      display: inline-block;
      font-size: 1.6rem;
      line-height: 1.6rem;
      margin-bottom: 0.5rem;
      padding: 1.4rem 0.8rem;

      &:focus {
        background-color: ${greyscale.lighter};
        outline: none;
      }

      &.disabled {
        cursor: not-allowed;
        color: ${greyscale.smoke};
        background-color: ${greyscale.cloud};
        opacity: 1;
      }
    }

    &__options-buttons {
      align-items: center;
      border-top: 1px solid ${greyscale.light};
      display: flex;
      justify-content: space-between;
      margin-bottom: -1.6rem;
      margin-left: -1.6rem;
      margin-right: -1.6rem;
      padding: 1.6rem;
    }

    &__options-section {
      background-color: ${greyscale.white};
      border: 1px solid ${blue.riverBed};
      border-radius: 0.4rem;
      padding: 1.6rem;
      position: absolute;
      width: 24rem;
      z-index: 1;
    }

    &__clear-btn,
    &__save-btn {
      cursor: pointer;
      font-size: 1.4rem;
      line-height: 1.7rem;
    }

    &__clear-btn {
      color: ${greyscale.light};
    }

    &__save-btn {
      color: ${greyscale.white};
      background-color: ${greyscale.outerSpace};
      border-radius: 0.4rem;
      padding: 0.8rem 1.6rem;
    }
  }

  .text-option-label {
    color: ${greyscale.outerSpace};
  }

  .checkmark {
    border-color: ${greyscale.outerSpace};
  }

  .active-check {
    background-color: ${greyscale.outerSpace};

    :after {
      border-color: ${greyscale.white} !important;
    }
  }
`;
export default SorterWrapper;
